module.exports = __webpack_public_path__ + "assets/28caa59780fbc7f42b1a2dbb3a5cf8bb.png";